import Vue from 'vue'
import eventHub from '../helpers/event-hub'

if (document.getElementById('vue-footer')) {

  const informations = JSON.parse(document.getElementById('cp_recrutement_json').innerText);
  const employer = informations.page_types.find(item => item.value === true);
  const candidate = informations.page_types.find(item => item.value === false);
  const page_type = informations.page_type;
  const main_url_employer = informations.main_url_employer;
  const main_url_candidate = informations.main_url_candidate;
  const related_page = informations.related_page;

  new Vue({
    el: '#vue-footer',
    data() {
      return {
        checkbox: {
          value: page_type,
          checkedLabel: employer.label,
          uncheckedLabel: candidate.label
        },
      }
    },
    mounted() {
    },
    created () {
      eventHub.$on(`header-switch`, (event) => {
        this.checkbox.value = event
      }),
      eventHub.$on(`main-switch`, (event) => {
        this.checkbox.value = event
      })
    },
    methods: {
      onChange(event) {
        eventHub.$emit('footer-switch', event)
        let url;
        if (related_page) {
          url = related_page
        } else {
          url = this.checkbox.value === true ?  main_url_candidate : main_url_employer;
        }
        window.open(url, '_self');
      }
    }
  })
}